import BaseLoader from './BaseLoader';

/**
 * SplitLoader
 *
 * extends the baseLoader specially for content
 * with one data source but multiple different targets in dom
 *
 * loads xhr for specific nodes
 * how to use:
 * data-tncp-autoloader="split" data-tncp-xhr="/this/is/my/resource"
 * data-tncp-splitloader-from="[data-entrypoint-planned]|[data-entrypoint-critical]" (divided by PIPE -> selectors which are used in content which comes back via xhr)
 * data-tncp-splitloader-to="[data-target-planned]|[data-target-critical]" (divided by PIPE -> these selectors are replaced by content from "data-tncp-splitloader-from")
 *
 */
export default class SplitLoader extends BaseLoader {

    constructor(selector) {
        super(selector);
        this.dataAttributes = this.elements.data();
    }

    onSuccess($element, response) {
        if (response.data.content !== '') {

            // make jquery object from response data
            const $content = $(response.data.content);

            // get the selector names from data attributes which act as entrypoint from response.data and target
            let fromSelectors = this.dataAttributes.tncpSplitloaderFrom.split('|');
            let toSelectors = this.dataAttributes.tncpSplitloaderTo.split('|');

            // iterate through fromSelectors
            _.forEach(fromSelectors, (fromSelector, index) => {

                // this is the selector / jquery object which will be filled onSuccess
                let $toSelector = $(toSelectors[index]);

                // this is the content fragment which will be used for replacing content
                let contentFragment = $content.filter(fromSelector).contents().unwrap();

                if ($toSelector.hasClass('u-skeleton')) {
                    $toSelector.removeClass('u-skeleton');
                }

                // finally replace the content
                $toSelector.html(contentFragment);
            });

        }
    }
}
